import { TextButton } from 'components/Buttons'
import { HeadlineM, Overline, Subtitle } from 'components/Text'
import React, { useState } from 'react'
import styled from 'styled-components'
import Colors from 'styles/Colors'
import media from 'styles/media'
import { ReactComponent as FileSVG } from 'svg/file.svg'

const Feedback: React.FC<{}> = () => {
  const [file, setFile] = useState(null)

  return (
    <Wrapper>
      <Label bullet>Technical support</Label>
      <Title>Help us get better. Submit feedback or raise an issue.</Title>
      <FormTitle>Leave us some feedback</FormTitle>
      <Form
        name="feedback"
        method="POST"
        data-netlify="true"
        netlify-honeypot="Robot ID"
        action="/thank-you/"
      >
        <input type="hidden" name="form-name" value="feedback" />

        <Input
          type="email"
          name="Email"
          required
          aria-required
          placeholder="Email*"
        />
        <Hidden>
          <label>
            Don't fill this out if you are human
            <Input type="text" name="Robot ID" />
          </label>
        </Hidden>
        <Input
          type="text"
          name="Summary"
          required
          aria-required
          placeholder="Topic*"
        />
        <Text placeholder="Description" name="Description" />
        <Upload>
          <File />
          {file ? file.name : 'Upload file'}

          <Input
            type="file"
            name="file"
            accept="image/png, image/jpeg"
            onChange={(e) => {
              setFile(e.target.files[0])
            }}
          />
        </Upload>
        <Submit type="submit">Get in touch</Submit>
      </Form>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 732px;
  margin: 192px auto 0;
  ${media.mobile} {
    width: calc(100% - 24px);
  }
`
const Label = styled(Overline)`
  ::after {
    color: ${Colors.blueYonder};
  }
`
const Title = styled(HeadlineM)`
  margin: 15px 0 96px;
  ${media.mobile} {
    font-size: 36px;
    margin-bottom: 48px;
  }
  ${media.fullWidth} {
    font-size: 54px;
  }
`
const FormTitle = styled(Subtitle)`
  margin-bottom: 24px;
`
const Form = styled.form`
  width: 100%;
  height: 592px;
  padding: 96px 88px 56px;
  background: white;
  position: relative;
  ${media.mobile} {
    padding: 21px 21px 48px;
    height: unset;
  }
`
const Input = styled.input`
  width: 100%;
  height: 48px;
  margin-bottom: 24px;
  border: solid 1px ${Colors.softBlack};
  border-radius: 0;
  background: rgba(124, 161, 161, 0.12);
  padding-left: 24px;
  font-family: 'Maison Neue Mono';
`

const Text = styled.textarea`
  font-family: 'Maison Neue Mono';
  width: 100%;
  height: 96px
  border: solid 1px ${Colors.softBlack};
  background: rgba(124, 161, 161, 0.12);
  color: ${Colors.softBlack};
  padding-left: 24px;
  padding-top: 14px;
  font-size: 16px;
  margin-bottom: 1.4vw;
  resize: none;
  border-radius: 0;
  box-shadow: none;
  border: solid 1px ${Colors.softBlack};
  margin-bottom: 24px
`

const Upload = styled.div`
  width: 100%;
  height: 96px;
  border: 1px dashed #141414;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(124, 161, 161, 0.12);
  font-family: 'Maison Neue Mono';
  cursor: pointer;
  input {
    opacity: 0;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    cursor: pointer;
  }
`
const File = styled(FileSVG)`
  width: 24px;
`
const Submit = styled(TextButton)`
  width: 136px;
  height: 40px;
  margin-top: 40px;
  border: solid 1px ${Colors.softBlack};
  background: transparent;
  font-weight: 500;
  position: relative;
  font-size: 16px;

  ${media.mobile} {
    width: 100%;
  }
`
const Hidden = styled.div`
  height: 0;
  width: 0;
  overflow: hidden;
`
export default Feedback
